import { useTranslation } from "react-i18next";
import { Trash2, Clock } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { TruncatedText } from "@/components/ui/truncated-text";

interface DeleteDefectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defectTitle: string;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export function DeleteDefectDialog({
  open,
  onOpenChange,
  defectTitle,
  onConfirm,
  isDeleting = false,
}: DeleteDefectDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[calc(100%-2rem)]">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-destructive" />
            {t("defects.deleteDialogTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <div className="min-w-0">
              <TruncatedText
                text={t("defects.deleteDialogDescription", { title: defectTitle })}
                maxLines={2}
                showTooltip={false}
              />
            </div>
            <p className="flex items-center gap-2 text-muted-foreground">
              <Clock className="h-4 w-4" />
              {t("defects.deleteDialogCannotUndo")}
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? t("common.delete") + "..." : t("common.delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
